import { ClientConfigModel } from "../../../data-model/clientConfig";
import { getStateName } from "../../../enums/usStates";
import Call from "../../../svg/call-icon";
import LocationIcon from "../../../svg/locationIcon";
import MedicalCard from "../../../svg/medicalCardIcon";

const ClientFacilityCard = (props: {
  healthCareData: ClientConfigModel;
  isActive: boolean;
}) => {
  return (
    <div
      className={
        props.isActive
          ? "hc-card__container active shadow-md"
          : "hc-card__container shadow-md"
      }
    >
      <div className="hc-card__hc-name">
        {props?.healthCareData.name || "Unknown"}
      </div>
      <div className="hc-card__other-details">
        <div className="hc-card__detail">
          <Call height="1rem" width="1rem" />
          {props?.healthCareData.PhoneNumber || "Unknown"}
        </div>
        <div className="hc-card__detail">
          <LocationIcon height="1rem" width="1rem" />
          {props?.healthCareData.Address?.State
            ? getStateName(props?.healthCareData.Address?.State)
            : "Unknown"}{" "}
          , USA
        </div>
        <div className="hc-card__detail">
          <MedicalCard height="1rem" width="1rem" />
          {props?.healthCareData.NPI || "Unknown"}
        </div>
      </div>
    </div>
  );
};

export default ClientFacilityCard;
